// utils/loadOneTrust.js

export function loadOneTrust() {
  if (window.OneTrust) {
    // Already loaded
    return;
  }

  // Define OptanonWrapper (required by OneTrust)
  window.OptanonWrapper = function () {
    // Optional: handle any callbacks here
  };

  const script = document.createElement("script");
  script.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
  script.type = "text/javascript";
  script.charset = "UTF-8";
  script.setAttribute(
    "data-domain-script",
    "0199a4e5-36e1-7557-a452-f9332254d990"
  );
  script.async = true;

  document.head.appendChild(script);
}
